<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getImportantNotify } from '@/api/getData'

export default {
  name: 'App',
  data() {
    return {
      admin: null
    }
  },
  async beforeCreate() {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      await this.$oss.getOSSClient(this)
      await new Promise(resolve => setTimeout(resolve, 120 * 1000))
    }
  },
  async created() {
    await this.checkAdmin()
  },
  methods: {
    async checkAdmin() {
      const adminObjStr = localStorage.getItem('adminObjStr')
      this.admin = adminObjStr ? JSON.parse(adminObjStr) : null
      const token = localStorage.getItem('accessToken')
      if (!this.admin || !token) {
        localStorage.removeItem('adminObjStr')
        localStorage.removeItem('accessToken')
        localStorage.removeItem('adminRoles')
        this.$message.info('请登录')
        await new Promise(resolve => setTimeout(resolve, 1500))
        this.$router.push('/login')
      } else {
        while (true) {
          await new Promise(resolve => setTimeout(resolve, 30 * 1000))
          const res = await getImportantNotify()
          if (res.code !== 0) continue

          const data = res.data
          for (const key in data) {
            switch (key) {
              case 'audit':
                if (data[key]) this.$store.dispatch('app/addAuditNotify')
                else this.$store.dispatch('app/clearAuditNotify')
                break;
              case 'smallSecretary':
                if (data[key]) this.$store.dispatch('app/addSmallSecretaryNotify')
                else this.$store.dispatch('app/clearSmallSecretaryNotify')
                break;
              case 'greetingAudit':
                if (data[key]) this.$store.dispatch('app/addGreetingAuditNotify')
                else this.$store.dispatch('app/clearGreetingAuditNotify')
                break;
              case 'realPeopleAudit':
                if (data[key]) this.$store.dispatch('app/addRealPeopleAuditNotifyNotify')
                else this.$store.dispatch('app/clearRealPeopleAuditNotifyNotify')
                break;
              case 'accusationAudit':
                if (data[key]) this.$store.dispatch('app/addAccusationAuditNotifyNotify')
                else this.$store.dispatch('app/clearAccusationAuditNotifyNotify')
                break;
              case 'shortVideoAudit':
                if (data[key]) this.$store.dispatch('app/addShortVideoAuditNotifyNotify')
                else this.$store.dispatch('app/clearShortVideoAuditNotifyNotify')
                break;

              default:
                break;
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.el-table th.gutter {
  display: table-cell !important;
}

.sys-set {
  .transform-set {
    .el-form-item__content {
      margin-left: 0px;
    }
  }
}
.invitations {
  .transform-set {
    .el-form-item__content {
      margin-left: 0px !important;
    }
  }
}

.img-upload {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}

.el-table .warning-row {
  background: oldlace;
}
</style>
